/**
 * Format a card number with spaces every 4 characters : 1234 5678 9012 3456 or 1234 56** **** 3456
 * @param cardNumber - The card number to format
 * @returns The formatted card number
 */
export const formatCardNumberWithSpaces = (cardNumber: string) => {
  const spaceCharacter = " ";
  const middleAsterikHTMLCharacter = "*";
  return cardNumber
    .replace(/[^a-zA-Z0-9*]/g, "")
    .split("")
    .reduce((acc: string[], char: string, index: number) => (index % 4 === 0 ? [...acc, " ", char] : [...acc, char]), [])
    .join("")
    .trim()
    .replace(/[*]/g, middleAsterikHTMLCharacter)
    .replace(/[ ]/g, spaceCharacter);
};
